import React from 'react';
import SaudiRiyalIcon from "components/atoms/SaudiRiyalIcon";
import { Box } from '@mui/material';

interface CurrencyDisplayProps {
  currency?: string;
  size?: number | string;
  style?: React.CSSProperties;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  currency = 'SAR',
  size,
  style
}) => {
  if (currency === 'SAR') {
    return (
      <SaudiRiyalIcon
        size={size ?? '1em'}
        style={{ verticalAlign: '-0.1em', ...style }}
      />
    );
  }

  return (
    <Box component="span" sx={{ ...style }}>
      {currency}
    </Box>
  );
};

export default CurrencyDisplay;
